export default {
  userList: [],
  userRole: [],
  userInfo: {},
  userCheck: false,
  userError: {},
  userRoleAssignPopup: false,
  userDeptAssignPopup: false,
  userId: '',
  srchParam: {},
  userExcelUploadPopup: false,
  myPagePopup: false,
  aprvlPopup: false,
  pwdPopup: false,
  myInfo: {},
  apvl: {},
  pwExpDate: '',
  excelData: [],
};
